import React, { Component, Fragment } from 'react';
import _ from 'lodash';

export default class OuterComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { key: _.uniqueId(''), ready: false };
    this._frameId = null;
  }

  componentDidMount() {
    this._frameId = requestAnimationFrame(() => {
      this._frameId = null;
      this.setState({ ready: true });
    });
  }

  componentDidUpdate(prevProps) {
    // Force remount when reporting date changes OR when route path changes
    const reportingDateChanged = this.props.force_reportingdate
      && prevProps.selectedReportingDate !== this.props.selectedReportingDate;
    const routeChanged = prevProps.routePath !== this.props.routePath;

    if (reportingDateChanged || routeChanged) {
      if (this._frameId) cancelAnimationFrame(this._frameId);
      this.setState({ key: _.uniqueId(''), ready: false });
      this._frameId = requestAnimationFrame(() => {
        this._frameId = null;
        this.setState({ ready: true });
      });
    }
  }

  componentWillUnmount() {
    if (this._frameId) cancelAnimationFrame(this._frameId);
  }

  render() {
    if (!this.state.ready) return null;
    return <Fragment key={this.state.key}>{this.props.children}</Fragment>;
  }
}
